export default "__VITE_ASSET__2791dc13__"